<template>
  <div>
    <div class="text-h4 font-weight-black blue--text mt-8 text-center">HOW TO INVEST</div>
    <v-flex class="mt-2 pa-2 px-md-16 pb-md-4 pt-md-8">
      <v-card elevation="0" width="100%" min-height="500" class="px-8 pb-8 px-md-16 pb-md-4">
        <v-card class="mb-5 mb-md-10" v-for="(item, index) in itemsInfografis" :key="index" >
          <v-img :src="lang==='id'? item.filenameId : item.filenameEn"></v-img>
        </v-card>
      </v-card>
    </v-flex>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: 'HowToInvestMain',
  components: {
    AppFooter
  },
  data(){
    return {
      itemsInfografis: [
        {id:3, filenameId: require("@/assets/images/infografis-id/Infografis_ID_03.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_03.jpg")},
        // {id:4, filenameId: require("@/assets/images/infografis-id/Infografis_ID_04.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_04.jpg")},
        {id:5, filenameId: require("@/assets/images/infografis-id/Infografis_ID_05.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_05.jpg")},
        {id:6, filenameId: require("@/assets/images/infografis-id/Infografis_ID_06.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_06.jpg")},
        {id:7, filenameId: require("@/assets/images/infografis-id/Infografis_ID_07.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_07.jpg")},
        {id:8, filenameId: require("@/assets/images/infografis-id/Infografis_ID_08.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_08.jpg")},
        {id:9, filenameId: require("@/assets/images/infografis-id/Infografis_ID_09.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_09.jpg")},
        {id:10, filenameId: require("@/assets/images/infografis-id/Infografis_ID_10.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_10.jpg")},
        {id:11, filenameId: require("@/assets/images/infografis-id/Infografis_ID_11.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_11.jpg")},
        {id:12, filenameId: require("@/assets/images/infografis-id/Infografis_ID_12.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_12.jpg")},
        {id:13, filenameId: require("@/assets/images/infografis-id/Infografis_ID_13.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_13.jpg")},
        {id:14, filenameId: require("@/assets/images/infografis-id/Infografis_ID_14.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_14.jpg")},
        {id:15, filenameId: require("@/assets/images/infografis-id/Infografis_ID_15.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_15.jpg")},
        {id:16, filenameId: require("@/assets/images/infografis-id/Infografis_ID_16.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_16.jpg")},
        {id:17, filenameId: require("@/assets/images/infografis-id/Infografis_ID_17.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_17.jpg")},
        {id:18, filenameId: require("@/assets/images/infografis-id/Infografis_ID_18.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_18.jpg")},
        {id:19, filenameId: require("@/assets/images/infografis-id/Infografis_ID_19.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_19.jpg")},
        {id:20, filenameId: require("@/assets/images/infografis-id/Infografis_ID_20.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_20.jpg")},
        {id:21, filenameId: require("@/assets/images/infografis-id/Infografis_ID_21.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_21.jpg")},
        {id:22, filenameId: require("@/assets/images/infografis-id/Infografis_ID_22.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_22.jpg")},
        // {id:23, filenameId: require("@/assets/images/infografis-id/Infografis_ID_23.jpg"), filenameEn: require("@/assets/images/infografis-en/Infografis_EN_23.jpg")},
      ]
    }
  },
  computed: {
    lang:{
      get(){
        return this.$store.state.langModule.lang
      },
      set(val) {
        this.$store.dispatch('langModule/setLang', val)
      }
    },
  },
  watch: {
    lang: {
      handler: function (val, oldVal) {
        if (val !== oldVal){
          // this.fetchFKomoditi()
        }
      }
    },
  },
  methods: {
  },
  mounted() {
  }

}
</script>

<style scoped>


</style>